export default __webpack_public_path__ + "dee9c538f06f5738b5eec9a86861536a.png";